import React, { useState, useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addGovernment, fetchCountries, clearError, clearSuccess } from '../../../redux/Slices/LocationsSlice';
import { showErrorToast, showSuccessToast } from '../../../shared/utils/toastHelper';

const AddGovernment = () => {
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const { countries, updating, error, success } = useSelector((state) => state.locations);

    const [formData, setFormData] = useState({
        name_ar: '',
        name_en: '',
        country_id: ''
    });

    useEffect(() => {
        setTitle('إضافة محافظة');
        dispatch(fetchCountries());
    }, [setTitle, dispatch]);

    useEffect(() => {
        if (error) {
            showErrorToast(error);
            dispatch(clearError());
        }
        if (success) {
            showSuccessToast(success);
            dispatch(clearSuccess());
            navigate('/admin-locations/governments');
        }
    }, [error, success, dispatch, navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!formData.name_ar || !formData.name_en || !formData.country_id) {
            showErrorToast('الرجاء تعبئة جميع الحقول المطلوبة');
            return;
        }

        const submitData = new FormData();
        submitData.append('name_ar', formData.name_ar);
        submitData.append('name_en', formData.name_en);
        submitData.append('country_id', formData.country_id);

        dispatch(addGovernment(submitData));
    };

    return (
        <div className="main_content">
            <div className="dashboard-container">
                <div className="card shadow-lg border-0">
                    <div className="card-header bg-white pb-0 border-0">
                        <h4 className="mb-0">إضافة محافظة جديدة</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <label className="form-label">الدولة <span className="text-danger">*</span></label>
                                    <select
                                        className="form-select hover-shadow transition-all"
                                        name="country_id"
                                        value={formData.country_id}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="" disabled>-- اختر الدولة --</option>
                                        {countries && countries.map(country => (
                                            <option key={country.id} value={country.id}>
                                                {country.name_ar || country.name || country.name_en}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">اسم المحافظة (بالعربية) <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control hover-shadow transition-all"
                                        name="name_ar"
                                        value={formData.name_ar}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="اكتب اسم المحافظة بالعربية"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">اسم المحافظة (بالإنجليزية) <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control hover-shadow transition-all"
                                        name="name_en"
                                        value={formData.name_en}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="اكتب اسم المحافظة بالإنجليزية"
                                    />
                                </div>
                            </div>
                            
                            <div className="mt-4 d-flex gap-2">
                                <button type="submit" className="btn btn-primary px-4 py-2" disabled={updating}>
                                    {updating ? 'جاري الحفظ...' : 'حفظ'}
                                </button>
                                <button type="button" className="btn btn-secondary px-4 py-2" onClick={() => navigate('/admin-locations/governments')} disabled={updating}>
                                    إلغاء
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddGovernment;
